import { Action, createReducer, on } from "@ngrx/store";
import { initialState } from "./post.state";
import { postActions } from "./post.actions";


export const postReducer = (actions$: ReturnType<typeof postActions>) => {
  return createReducer(
    initialState,
    on(
      actions$.move,
      (state, { target }) => {
        // console.log("POST REDUCER RAN", target)
        return {
          ...state,
          text: "STATE updated!!"
        }
      },
    ),
  );
}
